import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AppPlatformDataTableComponent } from './components/platform-datatable/platform-datatable.component';
import { AppPlatformDataTableInfiniteComponent } from './components/platform-datatable-infinite/platform-datatable-infinite.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FuseDirectivesModule } from '../template-atlas';

@NgModule({
    imports: [
        CommonModule,
        FuseDirectivesModule,
        NgxDatatableModule,
        MatTableModule,
        MatPaginatorModule,
        TranslateModule.forChild(),
        FlexLayoutModule.withConfig({
            useColumnBasisZero: false,
            printWithBreakpoints: [
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'lt-sm',
                'lt-md',
                'lt-lg',
                'lt-xl',
                'gt-xs',
                'gt-sm',
                'gt- md',
                'gt-lg'
            ]
        })
    ],
    declarations: [AppPlatformDataTableComponent, AppPlatformDataTableInfiniteComponent],
    exports: [AppPlatformDataTableComponent, AppPlatformDataTableInfiniteComponent, NgxDatatableModule]
})
export class PlatformDataTableModule {}
